import { schema } from 'normalizr'
import {
  parseCNSConnectorStringForDisplay,
  getVehicleTypeViaUri,
  determineInitialPinEditStatus,
} from 'utils/circuits'
import { prop } from 'ramda'
import { N_A } from 'constants/ecus'

const pinSchema = new schema.Entity(
  'pins',
  {},
  {
    idAttribute: (value, parent) => `${parent.uri}/${value.location}`,
    processStrategy: (value, parent) => {
      const { isChecPlus } = getVehicleTypeViaUri(parent.uri)

      const initialPinEditStatus = determineInitialPinEditStatus(
        value,
        parent,
        isChecPlus
      )
      const circuitNum = prop('circuitNumber', value)
      return {
        ...value,
        uri: `${parent.uri}/${value.location}`,
        ...(circuitNum && { circuitNumber: circuitNum || N_A }),
        ...(value.ecuPinUri && {
          sourceData: {
            uri: value.ecuPinUri,
          },
        }),
        ...(value.commonNodeSiblings && {
          commonNodeSiblings: value.commonNodeSiblings.reduce(
            (acc, sibling) => {
              const { connectorName, pins } = sibling
              const moduleName = parent.uri.split('/')[1]
              return [
                ...acc,
                ...pins.map((pin) => {
                  const { location } = pin
                  return {
                    label: `${parseCNSConnectorStringForDisplay(
                      connectorName,
                      moduleName
                    )}-${location}`,
                    uri: `/${moduleName}/${connectorName}/${location}`,
                  }
                }),
              ]
            },
            []
          ),
        }),
        ...(initialPinEditStatus && {
          status: initialPinEditStatus,
        }),
      }
    },
  }
)

const pinArraySchema = new schema.Array(pinSchema)

const connectorSchema = new schema.Entity(
  'connectors',
  {
    pins: pinArraySchema,
  },
  {
    idAttribute: (value, parent) => `${parent.uri}/${value.connectorName}`,
    processStrategy: (value, parent) => ({
      ...value,
      uri: `${parent.uri}/${value.connectorName}`,
    }),
  }
)

const connectorArraySchema = new schema.Array(connectorSchema)

const moduleSchema = new schema.Entity(
  'modules',
  {
    connectors: connectorArraySchema,
  },
  {
    idAttribute: (value) => `/${value.moduleName}`,
    processStrategy: (value) => ({
      ...value,
      uri: `/${value.moduleName}`,
    }),
  }
)

export const moduleArraySchema = new schema.Array(moduleSchema)

export const vehicleModulesSchema = new schema.Object({
  modules: moduleArraySchema,
})

export const exmResponseSchema = new schema.Object({
  vehicle: vehicleModulesSchema,
})

const circuitSchema = new schema.Entity(
  'circuits',
  {},
  {
    idAttribute: 'circuitNumber',
  }
)

const detailPinSchema = (module, connector) =>
  new schema.Entity(
    'pins',
    {},
    {
      idAttribute: (value) =>
        value.uri || `/${module}/${connector}/${value.location}`,
      processStrategy: (value) => ({
        ...value,
        uri: value.uri || `/${module}/${connector}/${value.location}`,
        // Keep features as objects (don't normalize) so UI can access feature properties directly
      }),
    }
  )

export const connectorPinsSchema = ({ module, connector }) =>
  new schema.Object({
    pins: [
      {
        pin: detailPinSchema(module, connector),
        circuit: circuitSchema,
      },
    ],
  })
